import { render } from "./WeddingGiftSection.vue?vue&type=template&id=179d86d3&scoped=true"
import script from "./WeddingGiftSection.vue?vue&type=script&lang=js"
export * from "./WeddingGiftSection.vue?vue&type=script&lang=js"

import "./WeddingGiftSection.vue?vue&type=style&index=0&id=179d86d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179d86d3"]])

export default __exports__